import React from 'react';
import { Link } from 'react-router-dom'
import DocumentDashboard from '../components/documentDashboard.js';



const Dashboard = ({ items, user }) => (
  <section className=''>
      <div className="mdl-grid">
        { items.map (item =>
            <div className="mdl-cell--no-spacing" key={item.id}>

                <DocumentDashboard item={item} user={user} />

            </div>
          )
        }
        <div className="mdl-cell--no-spacing">
          <Link className="mdl-button mdl-js-button mdl-button--fab mdl-button--colored" to='/newdocument'>
            <i className="material-icons">add</i>
          </Link>
        </div>

      </div>


  </section>
)

export default Dashboard



// WEBPACK FOOTER //
// ./src/containers/dashboard.js